import * as React from "react";
const SvgFiRrItComputer = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-it-computer__svg__a)">
      <path d="M5.938 10.5a1 1 0 0 0 1.366.366l.956-.552A5 5 0 0 0 11 11.899V13a1 1 0 1 0 2 0v-1.101a5 5 0 0 0 2.74-1.585l.956.552a.997.997 0 0 0 1.366-.366 1 1 0 0 0-.366-1.366l-.953-.55a4.992 4.992 0 0 0 0-3.166l.953-.55a1 1 0 0 0-1-1.732l-.956.552A5 5 0 0 0 13 2.103V1.002a1 1 0 1 0-2 0v1.1a5 5 0 0 0-2.74 1.586l-.956-.552a1.001 1.001 0 0 0-1 1.732l.953.55a4.992 4.992 0 0 0 0 3.166l-.953.55a1 1 0 0 0-.366 1.366M12 4c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m10 13.172V10a4.98 4.98 0 0 0-1.875-3.903 1 1 0 0 0-1.251 1.56A2.99 2.99 0 0 1 19.999 10v7h-4.5a1 1 0 0 0-.707.293l-.707.707H9.913l-.707-.707A1 1 0 0 0 8.499 17h-4.5v-7c0-.915.41-1.769 1.125-2.342a1 1 0 1 0-1.25-1.56A4.98 4.98 0 0 0 1.999 10v7.172a3 3 0 0 0-2 2.828c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3A3 3 0 0 0 22 17.172M21 21H3a1.001 1.001 0 0 1 0-2h5.086l.707.707A1 1 0 0 0 9.5 20h5c.265 0 .52-.105.707-.293l.707-.707H21a1.001 1.001 0 0 1 0 2" />
      <path d="M12 8.5a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 12 8.5" />
    </g>
    <defs>
      <clipPath id="fi-rr-it-computer__svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrItComputer;
